<template>
  <div class="mainAgenda" :style="{ 'padding-top': !isDate ? 0 : '1.5rem' }">
    <!-- 加载标识 -->
    <van-loading type="spinner" color="#1989fa" text-size=".4rem" vertical v-if="loading"
      >加载中...</van-loading
    >
    <!-- 暂无数据标识 -->
    <div v-if="noData" style="text-align: center; font-size: 0.5rem">暂无数据...</div>
    <!-- 日期栏区域 -->
    <div class="header" v-if="config.agenda_date && config.agenda_date.length && isDate">
      <div class="dateBox">
        <div
          class="date"
          v-for="item in config.agenda_date"
          :key="item"
          @click="GetAgendaList(item)"
          :class="{ check: item === currentDate }">
          <div class="month">{{ item.substring(5, 7) }}</div>
          <div class="day">{{ item.substring(8, 11) }}</div>
        </div>
      </div>

      <span
        class="isDateBtn"
        @click="showDate"
        v-show="!$route.query.date || $route.query.date == 'undefined'"
        ><svg
          t="1670308188990"
          class="icon"
          viewBox="0 0 1518 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="2746"
          width="50"
          height="50">
          <path
            d="M758.518519 104.296296c284.444444 0 530.962963 165.925926 644.740741 407.703704L1517.037037 512C1393.777778 213.333333 1099.851852 0 758.518519 0 417.185185 0 123.259259 213.333333 0 512l113.777778 0C227.555556 270.222222 474.074074 104.296296 758.518519 104.296296L758.518519 104.296296zM758.518519 104.296296M758.518519 919.703704c-284.444444 0-530.962963-165.925926-644.740741-407.703704L0 512c123.259259 298.666667 417.185185 512 758.518519 512 341.333333 0 635.259259-213.333333 758.518519-512l-113.777778 0C1289.481481 753.777778 1042.962963 919.703704 758.518519 919.703704L758.518519 919.703704zM758.518519 919.703704M758.518519 512m-274.962963 0a5.8 5.8 0 1 0 549.925926 0 5.8 5.8 0 1 0-549.925926 0Z"
            p-id="2747"
            fill="#cdcdcd"></path></svg
      ></span>
      <span
        class="isDateBtn"
        @click="showDate"
        v-show="$route.query.date && $route.query.date != 'undefined'">
        <svg
          t="1670308426439"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="3657"
          width="50"
          height="50">
          <path
            d="M900.266667 379.733333c-12.8-8.533333-34.133333-8.533333-42.666667 8.533334-136.533333 187.733333-396.8 226.133333-584.533333 93.866666-42.666667-29.866667-76.8-64-102.4-106.666666-8.533333-12.8-29.866667-17.066667-42.666667-8.533334-12.8 8.533333-17.066667 29.866667-8.533333 42.666667 29.866667 46.933333 72.533333 85.333333 115.2 119.466667 17.066667 12.8 38.4 25.6 55.466666 34.133333l-81.066666 81.066667c-12.8 12.8-12.8 34.133333 0 46.933333 4.266667 4.266667 12.8 8.533333 21.333333 8.533333s17.066667-4.266667 21.333333-8.533333L345.6 597.333333l4.266667-4.266666c42.666667 17.066667 85.333333 25.6 128 29.866666v119.466667c0 17.066667 12.8 34.133333 34.133333 34.133333s34.133333-12.8 34.133333-34.133333v-123.733333c38.4-4.266667 72.533333-8.533333 110.933334-17.066667 0 0 0 4.266667 4.266666 4.266667l93.866667 93.866666c4.266667 4.266667 12.8 8.533333 21.333333 8.533334s17.066667-4.266667 21.333334-8.533334c12.8-12.8 12.8-34.133333 0-46.933333l-76.8-76.8c72.533333-34.133333 136.533333-85.333333 187.733333-153.6 8.533333-12.8 4.266667-29.866667-8.533333-42.666667z"
            fill="#cdcdcd"
            p-id="3658"></path>
        </svg>
      </span>
    </div>
    <!-- 搜索区域 -->
    <van-search
      v-if="newAgendaList.length && $route.query.event_id != 1310"
      placeholder="请输入讲者主持人姓名查询"
      clear-trigger="always"
      @focus="
        $router.push(
          `/subpages/guestSearch?event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${currentDate}&listDate=${$route.query.listDate}&listPlace=${$route.query.listPlace}&listGroup=${$route.query.listGroup}`
        )
      " />
    <!-- 日程表格 -->
    <div class="tableBox">
      <div class="table">
        <!-- 行 -->
        <div class="tr" v-for="item in newAgendaList" :key="item.VenueNameCN">
          <span class="title">
            <span>{{ item.VenueNameCN }}</span>
            <span class="showTitle" @click="isShowAgenda(item.VenueNameCN)">
              <span v-show="isAgenda.includes(item.VenueNameCN)"
                ><svg
                  t="1670308188990"
                  class="icon"
                  viewBox="0 0 1518 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2746"
                  width="50"
                  height="50">
                  <path
                    d="M758.518519 104.296296c284.444444 0 530.962963 165.925926 644.740741 407.703704L1517.037037 512C1393.777778 213.333333 1099.851852 0 758.518519 0 417.185185 0 123.259259 213.333333 0 512l113.777778 0C227.555556 270.222222 474.074074 104.296296 758.518519 104.296296L758.518519 104.296296zM758.518519 104.296296M758.518519 919.703704c-284.444444 0-530.962963-165.925926-644.740741-407.703704L0 512c123.259259 298.666667 417.185185 512 758.518519 512 341.333333 0 635.259259-213.333333 758.518519-512l-113.777778 0C1289.481481 753.777778 1042.962963 919.703704 758.518519 919.703704L758.518519 919.703704zM758.518519 919.703704M758.518519 512m-274.962963 0a5.8 5.8 0 1 0 549.925926 0 5.8 5.8 0 1 0-549.925926 0Z"
                    p-id="2747"
                    fill="#cdcdcd"></path></svg
              ></span>
              <span v-show="!isAgenda.includes(item.VenueNameCN)"
                ><svg
                  t="1670308426439"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3657"
                  width="50"
                  height="50">
                  <path
                    d="M900.266667 379.733333c-12.8-8.533333-34.133333-8.533333-42.666667 8.533334-136.533333 187.733333-396.8 226.133333-584.533333 93.866666-42.666667-29.866667-76.8-64-102.4-106.666666-8.533333-12.8-29.866667-17.066667-42.666667-8.533334-12.8 8.533333-17.066667 29.866667-8.533333 42.666667 29.866667 46.933333 72.533333 85.333333 115.2 119.466667 17.066667 12.8 38.4 25.6 55.466666 34.133333l-81.066666 81.066667c-12.8 12.8-12.8 34.133333 0 46.933333 4.266667 4.266667 12.8 8.533333 21.333333 8.533333s17.066667-4.266667 21.333333-8.533333L345.6 597.333333l4.266667-4.266666c42.666667 17.066667 85.333333 25.6 128 29.866666v119.466667c0 17.066667 12.8 34.133333 34.133333 34.133333s34.133333-12.8 34.133333-34.133333v-123.733333c38.4-4.266667 72.533333-8.533333 110.933334-17.066667 0 0 0 4.266667 4.266666 4.266667l93.866667 93.866666c4.266667 4.266667 12.8 8.533333 21.333333 8.533334s17.066667-4.266667 21.333334-8.533334c12.8-12.8 12.8-34.133333 0-46.933333l-76.8-76.8c72.533333-34.133333 136.533333-85.333333 187.733333-153.6 8.533333-12.8 4.266667-29.866667-8.533333-42.666667z"
                    fill="#cdcdcd"
                    p-id="3658"></path></svg
              ></span>
            </span>
          </span>
          <!-- 行内项目 -->
          <div class="tableBody">
            <span
              class="item"
              v-for="i in item.Agendas[0].AMAgendas"
              :key="i.id"
              @click="to(i.id)"
              :style="{
                background: i.agenda_color == '0' ? 'rgba(64, 158, 255, 0.14)' : i.agenda_color,
              }">
              <div class="time">
                <img class="icon" src="@/assets/image/biao.png" alt="" />
                {{ i.start_time }}-{{ i.end_time }}
              </div>
              <div class="text">{{ i.agenda_title }}</div>
            </span>
            <span
              class="item"
              v-for="i2 in item.Agendas[0].PMAgendas"
              :key="i2.id"
              @click="to(i2.id)"
              :style="{
                background: i2.agenda_color == '0' ? 'rgba(64, 158, 255, 0.14)' : i2.agenda_color,
              }">
              <div class="time">
                <img class="icon" src="@/assets/image/biao.png" alt="" />
                {{ i2.start_time.substr(0, 5) }}-{{ i2.end_time.substr(0, 5) }}
              </div>
              <div class="text">{{ i2.agenda_title }}</div>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 切换列表模式按钮 -->
    <button
      class="toggleButton"
      v-if="newAgendaList.length && $store.state.agendaConfig.show_type != 2"
      @click="
        $router.push(
          `/MainAgendaList?event_id=${$route.query.event_id}&isAgenda=${$route.query.isAgenda}&date=${$route.query.date}&currentDate=${currentDate}&listDate=${$route.query.listDate}&listPlace=${$route.query.listPlace}&listGroup=${$route.query.listGroup}`
        )
      ">
      <img src="@/assets/image/listIcon.png" alt="" />
      列表模式
    </button>
  </div>
</template>

<script>
import { getAgendaConfig, getAgendaList } from '@/api';
import 'vant/lib/notify/style';
import { Notify } from 'vant';

export default {
  data() {
    return {
      // 初始日程列表
      agendaList: [],
      // 日期数组
      date: [],
      // 日程列表
      newAgendaList: [],
      // 筛选后日期列表
      isAgendaList: [],
      // 搜索内容
      searchVal: '',
      // 当前日期
      currentDate: '',
      // 数据标识
      noData: false,
      // 加载标识
      loading: false,
      // 是否筛选日期
      isDate: true,
      // 是否筛选日程
      isAgenda: [],
      config: {},
    };
  },
  async created() {
    await this.GetAgendaConfig();
    if (!this.$route.query.currentDate) {
      // 创建一个Date对象
      const today = new Date();

      // 获取年、月、日
      const year = today.getFullYear();
      let month = today.getMonth() + 1; // 月份从0开始，所以要加1
      let day = today.getDate();

      // 格式化月份和日期，确保为两位数
      month = (month < 10 ? '0' : '') + month;
      day = (day < 10 ? '0' : '') + day;

      // 格式化日期
      const formattedDate = year + '-' + month + '-' + day;
      // const formattedDate = '2024-05-23';
      console.log('🚀 ~ created ~ formattedDate:', formattedDate);
      // 获取日程列表
      this.GetAgendaList(
        this.config.agenda_date.includes(formattedDate) ? formattedDate : this.config.agenda_date[0]
      );
    } else {
      // 获取日程列表
      this.GetAgendaList(
        this.config.agenda_date.includes(this.$route.query.currentDate)
          ? this.$route.query.currentDate
          : this.config.agenda_date[0]
      );
    }

    // 判断是否显示日期栏
    this.isShowDate();
  },
  methods: {
    scrollToElement() {
      const target = document.querySelector('.check');
      console.log('🚀 ~ scrollToElement ~ target:', target);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth', // 平滑滚动效果
        });
      }
    },
    async GetAgendaConfig() {
      try {
        const { data } = await getAgendaConfig(this.$route.query.event_id);
        console.log(data);
        if (data.code == 1) {
          this.config = data.data;
        } else {
          Notify({ type: 'warning', message: data.msg });
        }
      } catch (error) {}
    },
    // 前往主日程列表
    to(agenda_id) {
      this.$router.push(
        `/subpages?agenda_id=${agenda_id}&event_id=${this.$route.query.event_id}&isAgenda=${this.$route.query.isAgenda}&date=${this.$route.query.date}&currentDate=${this.currentDate}&listDate=${this.$route.query.listDate}&listPlace=${this.$route.query.listPlace}&listGroup=${this.$route.query.listGroup}`
      );
    },
    // 获取日程列表
    async GetAgendaList(date) {
      this.newAgendaList = [];
      this.loading = true;
      const { data } = await getAgendaList({
        event_id: this.$route.query.event_id,
        agenda_date: date,
      });
      if (data.data) {
        // 日程列表赋值
        this.agendaList = data.data.result;
        // 日期列表赋值

        // 如果有筛选日程，过滤出是筛选的日程和日期栏放在isAgendaList
        if (
          this.$route.query.isAgenda &&
          this.$route.query.isAgenda != 'undefined' &&
          JSON.parse(this.$route.query.isAgenda).length
        ) {
          this.isAgendaList = this.agendaList.filter((item) => {
            return JSON.parse(this.$route.query.isAgenda).includes(item.VenueNameCN);
          });
          // this.date = this.date.filter((item) => {
          //   return this.isAgendaList.filter((i) => {
          //     return i.Agendas.filter((i2) => {
          //       return i2.Date == item && (i2.AMAgendas.length != 0 || i2.PMAgendas.length != 0);
          //     }).length;
          //   }).length;
          // });
        }

        // 根据日期筛选日程列表
        this.screenDate(
          this.$route.query.date != 'undefined' && this.$route.query.date
            ? this.$route.query.date
            : date
        );
      }
      this.loading = false;
      // 判断数据标识
      if (this.config.agenda_date.length === 0) this.noData = true;
    },

    // 筛选日期
    screenDate(date) {
      // 判断是否过滤了日程，过滤了按过滤列表筛选日期
      if (this.isAgendaList.length != 0) {
        let list = JSON.parse(JSON.stringify(this.isAgendaList));
        // 筛选日期
        this.newAgendaList = list;
        this.currentDate = date;
      } else {
        let list = JSON.parse(JSON.stringify(this.agendaList));
        // 筛选日期
        this.newAgendaList = list;
        this.currentDate = date;
      }
      this.$nextTick(() => {
        this.scrollToElement();
      });
      if (!this.$route.query.currentDate) {
        this.addQuery('currentDate', this.currentDate);
      }
    },

    // 在地址栏增加参数
    addQuery(keyVal, value) {
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          [keyVal]: value,
        },
      });
    },

    // 显示隐藏日期按钮回调
    showDate() {
      if (this.$route.query.date && this.$route.query.date != 'undefined') {
        this.$router.push({
          path: this.$route.fullPath,
          query: { date: '' },
        });
        return;
      }
      this.$router.push({
        path: this.$route.fullPath,
        query: { date: this.currentDate },
      });
    },
    // 判断是否显示日期
    isShowDate() {
      if (this.$route.query.date != 'undefined' && this.$route.query.date) this.isDate = false;
      this.isAgenda =
        this.$route.query.isAgenda != 'undefined' && this.$route.query.isAgenda
          ? JSON.parse(this.$route.query.isAgenda)
          : [];
    },
    isShowAgenda(name) {
      if (this.isAgenda.includes(name)) {
        this.isAgenda = this.isAgenda.filter((item) => {
          return item != name;
        });
        this.$router.push({
          path: this.$route.fullPath,
          query: { isAgenda: JSON.stringify(this.isAgenda) },
        });
        return;
      }

      if (!this.isAgenda.includes(name)) this.isAgenda.push(name);
      this.$router.push({
        path: this.$route.fullPath,
        query: { isAgenda: JSON.stringify(this.isAgenda) },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mainAgenda {
  padding: 1.5rem 0;
}
.header {
  position: fixed;
  top: 0;
  z-index: 99;
  padding: 0 0.8rem 0 0.1rem;
  box-sizing: border-box;
  width: 100%;
  height: 1.5rem;
  background: #ffffff;
  box-shadow: 0px -2px 24px 0px rgba(0, 0, 0, 0.2);
  .dateBox {
    overflow-x: auto;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
.isDateBtn {
  position: absolute;
  right: 0;
  top: 40%;
}
.date.check {
  border: 1px solid #409eff;
}
.date.check .day {
  background-color: #409eff;
}
.date.check .month {
  color: #409eff;
}
.date {
  flex-shrink: 0;
  height: 70%;
  width: 1.2rem;
  margin-left: 0.2rem;
  border: 1px solid #bdbdbd;
  border-radius: 0.2rem;
  overflow: hidden;
  text-align: center;
  .month {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #bdbdbd;
    background-color: #fff;
    height: 50%;
  }
  .day {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: #bdbdbd;
    height: 50%;
  }
}
.van-cell {
  line-height: 1rem;
}

.van-search__content {
  background-color: #ececec;
  border-radius: 0.3rem;
}
.van-cell {
  color: #b0b0b0;
  font-size: 0.3rem;
}

::v-deep .van-field__body {
  font-size: 0.4rem;
}

::v-deep .van-field__left-icon .van-icon,
.van-field__right-icon .van-icon {
  display: block;
  font-size: 0.7rem;
  line-height: inherit;
}

.van-search {
  margin-top: 0.5rem;
  padding: 10px 0.6rem;
}

::v-deep .van-field__clear {
  color: #c8c9cc;
  font-size: 0.5rem;
  cursor: pointer;
}

.table {
  width: 85%;
  overflow: auto;
  margin-left: 1.8rem;
  .tr {
    width: auto;
    white-space: nowrap;
  }

  .tr {
    margin-top: 0.2rem;
    .title {
      position: absolute;
      left: 0.3rem;
      box-sizing: border-box;
      overflow: hidden;
      font-weight: bold;
      display: inline-block;
      background: rgba(64, 158, 255, 0.14);
      border-radius: 0.1rem;
      white-space: normal;
      padding: 0.2rem 0.1rem 0.2rem 0.2rem;
      width: 1.8rem;
      height: 3rem;
      .showTitle {
        height: 0.5rem;
        position: absolute;
        bottom: 0;
        right: 0;
      }
      span {
        overflow: hidden;
        display: flex;
        align-items: center;
        height: 2.6rem;
        justify-content: center;
      }
    }
    .tableBody {
      margin-left: 0.32rem;
      min-height: 3rem;
      .item {
        color: #000;
        overflow: hidden;
        box-sizing: border-box;
        padding-left: 0.4rem;
        padding-top: 0.2rem;
        padding-right: 0.2rem;
        background: rgba(64, 158, 255, 0.14);
        border-radius: 0.1rem;
        margin-left: 0.1rem;

        width: 3rem;
        height: 3rem;
        vertical-align: top;
        white-space: normal;
        .text {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

.toggleButton {
  position: fixed;
  bottom: 0;
  margin-top: 1rem;
  padding: 0.2rem 0;
  width: 100%;
  background: #efefef;
  border: 0px solid #000000;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #949494;
  font-size: 0.4rem;
  img {
    width: 0.4rem;
  }
}

.table .tr span:nth-child(1) {
  background-color: #409eff;
  color: #fff;
}
</style>

<style>
.van-notify {
  line-height: 1rem;
  font-size: 0.5rem;
}
</style>
